import { convertToProxyUrl } from '../../utils/photoProxy';

/** Minimal shape shared by audience members and recent signups. */
export interface AudiencePersonLike {
  facePicture?: string | null;
  publicPicture?: string | null;
  profilePicture?: string | null;
  neighborhood?: string | null;
  city?: string | null;
  state?: string | null;
}

/**
 * Pick the best available avatar for admin display and run it through the
 * Google-photo proxy. Mirrors the app's face → public → profile preference.
 */
export function audienceAvatarUrl(p: AudiencePersonLike): string | undefined {
  const raw = p.facePicture || p.publicPicture || p.profilePicture || null;
  return convertToProxyUrl(raw) || undefined;
}

/**
 * Full neighborhood → city → state chain, most specific first, de-duped and
 * joined with middots. Returns '—' when nothing is set.
 */
export function audienceLocationText(p: AudiencePersonLike): string {
  const parts = [p.neighborhood, p.city, p.state]
    .map((v) => (v ? String(v).trim() : ''))
    .filter(Boolean);
  const seen = new Set<string>();
  const unique = parts.filter((v) => {
    const key = v.toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  return unique.length ? unique.join(' · ') : '—';
}
